function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M31.5 19C38.4036 19 44 24.5964 44 31.5C44 31.6995 43.9953 31.898 43.9861 32.0952H44V44H32.0952V43.9861C31.898 43.9953 31.6995 44 31.5 44C24.5964 44 19 38.4036 19 31.5C19 24.5964 24.5964 19 31.5 19Z",
  fill: "#FF5670"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35 11.0118C34.9958 11.0078 34.9915 11.0039 34.9872 11H35V11.0118ZM26.2232 13.5089H23.0804V23.9196L32.0179 29.3214L33.4911 26.7679L26.2232 22.3482V13.5089Z",
  fill: "#FF5670"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.5 8.5C34.8333 4.83333 30.381 3 25.1429 3C19.9048 3 15.4524 4.83333 11.7857 8.5C8.11905 12.1667 6.28571 16.619 6.28571 21.8571H0L8.15179 30.0089L8.25 30.3036L16.7946 21.8571H10.5089C10.5089 17.7976 11.933 14.3438 14.7812 11.4955C17.6295 8.64732 21.0833 7.22321 25.1429 7.22321C28.9597 7.22321 32.2411 8.48214 34.9872 11H35V11.0118C35.1702 11.1682 35.3384 11.3294 35.5045 11.4955C38.3527 14.3438 39.7768 17.7976 39.7768 21.8571C39.7768 25.9167 38.3527 29.3705 35.5045 32.2188C32.6562 35.067 29.2024 36.4911 25.1429 36.4911C21.0833 36.4911 17.6458 35.0506 14.8304 32.1696L11.7857 35.2143C15.5179 38.881 19.9702 40.7143 25.1429 40.7143C30.381 40.7143 34.8333 38.881 38.5 35.2143C42.1667 31.5476 44 27.0952 44 21.8571C44 16.619 42.1667 12.1667 38.5 8.5Z",
  fill: "#0E185B"
});

var SvgTimer = function SvgTimer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer.11d4b530.svg";
export { ForwardRef as ReactComponent };